// src/pages/Thanks.js
import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";

export default function Thanks() {
  const navigate = useNavigate();

  const formStyle = {
    maxWidth: "700px",
    margin: "auto",
    padding: "2rem",
    background: "#fff",
    borderRadius: "4px",
    boxShadow: "0 0 10px rgba(0,0,0,0.05)",
  };

  return (
    <>
      <div style={{ background: "#f4f4f4", minHeight: "100vh", padding: "2rem" }}>
        <div style={formStyle}>
          <h3 style={{ marginTop: 0, marginBottom: "1.5rem" }}>お疲れ様でした。</h3>
          <CustomButton
            kind="secondary"
            onClick={() => navigate("/summary")}
          >
            結果を確認する
          </CustomButton>
        </div>
      </div>
    </>
  );
}
